import { ShopSentMailType } from '@/models/liftoperator';

export const integrations = [
    {
        type: 'NONE',
        label: 'keine Anbindung',
    },
    {
        type: 'DTA',
        label: 'Skidata-DTA',
    },
    {
        type: 'BEI',
        label: 'Skidata-BEI',
    },
    {
        type: 'AXESS',
        label: 'AXESS',
    },
];

export const smartPricerEnvironments = [
    {
        type: 'PRODUCTION',
        label: 'Production',
    },
    {
        type: 'DEVELOPMENT',
        label: 'Development',
    },
];

// Customer mails a lift operator's own shop (e.g. Micado) can send itself
export const shopSentMailTypes: { type: ShopSentMailType; label: string }[] = [
    { type: 'ORDER_CONFIRMATION', label: 'Bestellbestätigung' },
    { type: 'TICKET_KEYCARD', label: 'Ticketbestätigung Keycard' },
    { type: 'TICKET_PICKUP', label: 'Ticketbestätigung Pick-up-Voucher' },
    { type: 'TICKET_ETICKET', label: 'Ticketbestätigung Smartphoneticket' },
    { type: 'TICKET_BARCODE', label: 'Ticketbestätigung Barcode-Ticket' },
    {
        type: 'TICKET_INTERNAL',
        label: 'Ticketbestätigung Keycard versendet durch Bergbahn',
    },
    { type: 'KEYCARD_SHIPPED', label: 'Keycard versendet' },
    { type: 'TICKET_CANCELLATION', label: 'Stornobestätigung' },
];
